module.exports = __webpack_public_path__ + "images/init-notification@2x-2947b0e85b2081f2a2cff76c3222c2e1.png";